export default {
    meta: {
        title: '鱼你在一起-草稿箱',
        url: '/fishtogether/chancepointdraft',
        urlName: '鱼你机会点草稿'
    }
};
